import type { SVGProps } from 'react'

export const PaletteFilledIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M480-71.87q-83.63 0-158.09-32.22-74.45-32.21-130.03-87.79-55.58-55.58-87.79-130.04-32.22-74.46-32.22-158.09 0-84.66 32.98-159.1 32.98-74.43 89.55-129.63 56.58-55.19 132-87.29 75.41-32.1 161.02-32.1 81.54 0 154.09 28.1 72.56 28.1 127.37 77.67 54.82 49.58 87.03 117.44 32.22 67.86 32.22 146.44 0 116.44-70.36 181.52-70.36 65.09-173.47 65.09h-68.5q-8.04 0-11.42 4.52-3.38 4.52-3.38 10.28 0 11.53 13.57 31.16 13.56 19.63 13.56 47.43 0 51.91-30.13 79.26-30.13 27.35-78 27.35ZM262.87-440q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm118.56-157.85q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm197.14 0q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17ZM696.41-440q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Z" />
    </svg>
  )
}
